import React, { useContext, useEffect, useState } from "react";
import { InvestFormContext } from "./contexts/InvestFormContext";
import { InvestTransactionContext } from "./contexts/InvestTransactionContext";
import { InvestCardComponent } from "./InvestCardComponent";
import { Box, Stack, Typography } from "@mui/material";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import FormCheckBox from "../../../../components/form/formCheckBox";
import listingServices from "../../../../services/listingServices";

export const ConditionsCard = React.memo(() => {
    const { termsAccepted, setAccepted, setAssetTermsId } = useContext(InvestFormContext);
    const { selectedMode, listing, url } = useContext(InvestTransactionContext);
    const [document, setDocument] = useState(null);
    const [conditions, setConditions] = useState([
        {
            title: "I consent to make my investment towards equitable, undivided co-ownership of the selected property as a financial investment and hold it in digital form through a secure registry maintained by Realx for the same",
            checked: termsAccepted,
        },
        {
            title: "I agree to the terms of the Instrument of Partition and consent to make it part of the instrument of Purchase of the selected property.",
            checked: termsAccepted,
        },
        {
            title: "I mandate RealX Trust I to register the property on my behalf and hold the title on behalf of me and all the co-owners.",
            checked: termsAccepted,
        },
        {
            title: "I mandate Realx to collect the rent and other income from the above property and process it in my bank account directly, after appropriate deductions towards various applicable fees and charges.",
            checked: termsAccepted,
        },
    ]);

    const assetTermsAndConditions = async () => {
        const res = await listingServices.getAssetTermsAndConditions(listing.assetClassId);
        if(res.success){
            const record = res.data;
            setConditions(
                (record?.points ?? [])
                  .slice()
                  .sort((a, b) => a.order - b.order)
                  .map((e) => ({ title: e.content, checked: termsAccepted }))
              );
            if(record?._id){
                setAssetTermsId(record._id);
            }
            if(record?.documentId?.docUrl){
                setDocument(record.documentId);
            }
        }
    }

    const handleChange = (value, index) => {
        setConditions(prev => prev.map((e, i) => ({
            ...e,
            checked: i === index ? value : e.checked
        })))
    }

    const selectAll = (value) => {
        setConditions(prev => prev.map((e, i) => ({
            ...e,
            checked: value
        })))
    }

    useEffect(() => {
        setAccepted(!(conditions?.find((e) => e.checked === false)))
        // eslint-disable-next-line
    }, [conditions])

    useEffect(() => {
        if(listing?.propertyType === "Asset" && listing?.assetClassId){
        assetTermsAndConditions();
        }
    }, [listing]);

    useEffect(() => {
        if (listing?.propertyType === "Asset" && listing?.assetClassId) return;
        if (selectedMode === 1) {
            setConditions([
                {
                    title: "I consent to make my investment towards equitable, undivided co-ownership of the selected property as a financial investment and hold it in digital form through a secure registry maintained by RealX for the same.",
                    checked: termsAccepted,
                },
                {
                    title: "I agree and authorise the usage of my investment towards payment as consideration for purchase of the property I'm investing in.",
                    checked: termsAccepted,
                },
                {
                    title: "I agree to the terms of the Instrument of Partition and consent to make it part of the instrument of Purchase of the selected property.",
                    checked: termsAccepted,
                },
                {
                    title: "I mandate the Custodian to register the property on my behalf and hold the title on behalf of me and all the co-owners.",
                    checked: termsAccepted,
                },
                {
                    title: "I mandate RealX to collect the rent and other income from the above property and process it in my bank account or wallet directly, after appropriate deductions towards various applicable fees and charges.",
                    checked: termsAccepted,
                },
            ])
        }
        else if (selectedMode === 0) {
            setConditions([
                {
                    title: "I consent to make my investment towards Property Tokens of the selected property as a financial investment and hold it in digital form as Non Fungible Tokens issued to me in my wallet. I understand that the NFT represents Right to Co-Ownership.",
                    checked: termsAccepted,
                },
                {
                    title: "I understand that NFT represents a beneficial interest, but not yet a direct right in the property until I exerccise the right, subject to eligibility and other conditions, to convert my ownership into Registered Co-Owner by exhausting the Token.",
                    checked: termsAccepted,
                },
                {
                    title: "I consent to agree to the Registered Co-Ownership terms should I decide to convert my  Ownership Mode to Registered Co-Ownership.",
                    checked: termsAccepted,
                },
            ])
        }
        selectAll(false);
        // eslint-disable-next-line
    }, [selectedMode])

    return (
        <InvestCardComponent title={"Terms & Conditions:"}>
            <Stack spacing={"20px"} direction="column">
                {
                    conditions?.map((e, i) => {
                        return (
                            <Box key={i}>
                                    <FormCheckBox
                                        value={e.checked}
                                        onChange={(j) => handleChange(j.target.checked, i)}
                                        label={e.title}
                                    />
                            </Box>
                        )
                    })
                }
                                {document?.docUrl ? (
                    <Box>
                        <Typography
                            component="a"
                            href={`${url ?? ""}${document.docUrl}`}
                            target="_blank"
                            rel="noreferrer"
                            variant="body2"
                            sx={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "10px",
                                fontWeight: 500,
                                color: "primary",
                                textDecoration: "none",
                            }}
                        >
                            <DescriptionOutlinedIcon sx={{ fontSize: 18 }} />
                            View Full Document
                            <OpenInNewIcon sx={{ fontSize: 18 }} />
                        </Typography>
                    </Box>
                ) : null}
                <Box>
                    <FormCheckBox
                        value={termsAccepted}
                        onChange={(j) => { setAccepted(j.target.checked); selectAll(j.target.checked) }}
                        labelStyle={{
                            fontWeight: 600
                        }}
                        label={listing?.propertyType === "Asset" && listing?.assetClassId ? "I agree to the Terms & Conditions." : "I understand and consent to above."}
                    />
                </Box>
            </Stack>
        </InvestCardComponent>
    )
})
